'use strict';

/**
 * This is a mask builder, you call it every time you want to mask some values or re-render values with a mask.
 * @param {string} selector CSS selector of the element to apply the mask
 * @returns {object} Returns an object with the masks to use
 */
function maskValues(selector) {
    return {
        phone: function (value) {
            if (typeof value === 'string') {
                return masks.phone({value});
            } else {
                init(masks.phone, selector);

                $(selector).on('keydown', function () {
                    masks.phone({input: this});
                });
            }
        }
    };
}

/**
 * Initialize the mask by changing the raw values to masked values found in the CSS selector chosen.
 * @param {function} mask Function to run mask, for example, (masks.phone)
 * @param {string} selector CSS selector of the element to apply the mask
 * @returns {void}
 */
function init(mask, selector) {
    $(selector).map(function () {
        var $this = $(this);

        if ($this.length && $this[0].nodeName !== 'INPUT') {
            $this.html(mask({value: $this.text()}));
        } else {
            this.value = mask({input: this});
        }
    });
}

var masks = {
    phone: function ({input, value}) {
        var phone = typeof value === 'string' ? value : input ? input.value : '';

        if (phone) {
            phone = phone.replaceAll(/\D/g, '');

            if (phone.length > 3) {
                phone = phone.replace(/.{3}/, '$&-');
            }

            if (phone.length > 7) {
                phone = phone.replace(/.{7}/, '$&-');
            }
        }

        if (input) {
            input.value = phone;
        }
        return phone;
    }
};

module.exports = {
    maskValues
};
